const updateHidden = (hidden, checked, ids) => {
  if (checked) {
    return hidden.filter((i) => !(ids.includes(i) || ids.includes(`meta.${i}`)));
  }
  return [...new Set(hidden.concat(ids))];
};

export default updateHidden;
